<template>
  <div
    class="base-shadow bg-background-neutral-secondary flex h-full flex-col space-y-2 rounded-2xl px-4 py-3"
  >
    <FareDescription :choice="choice" :fare-idx="fareIdx">
      <template #button>
        <FreeButton
          type="button"
          size="sm"
          class="w-2/5 py-2 text-base font-semibold"
          :class="[
            selectedId === choice.id ? 'gray-button' : 'green-main-button',
          ]"
          @click="handleFareSelect"
        >
          {{
            selectedId === choice.id
              ? $t('fareFamily.selected')
              : $t('general.select')
          }}
        </FreeButton>
      </template>
      <template
        #cashback="{ cashbackAmount, isCashbackError, isCashbackLoading }"
      >
        <slot
          name="cashback"
          v-bind="{ cashbackAmount, isCashbackError, isCashbackLoading }"
        />
      </template>
    </FareDescription>
  </div>
</template>

<script setup lang="ts">
  import { useRoute } from 'vue-router';
  import { isNil } from 'lodash-es';
  import { FreeButton } from 'freedom-shared';

  import { FareDescription } from '@/features/fare-family';

  import { analyticsEventsLib } from '@/shared/lib';
  import type { amplitudeEventsConfigTypes } from '@/shared/config';

  import type { FareFamilyChoiceSpec } from '../model';

  const props = defineProps<{
    choice: FareFamilyChoiceSpec;
    fareIdx: number;
    providerClass?: string;
    selectedId?: number | null;
    isDomestic?: boolean;
  }>();

  const emit = defineEmits<{ onFareSelect: [] }>();
  const route = useRoute();

  const handleFareSelect = () => {
    analyticsEventsLib.selectFareFamily({
      choice: props.choice,
      source: route.params
        .source as amplitudeEventsConfigTypes.DetailsPageOpenSource,
      fareFamilyName: props.choice.name,
      descriptions: props.choice.descriptions,
      isBaseFare: isNil(props.choice.code),
      fareIdx: props.fareIdx,
      providerClass: props.providerClass,
      isDomestic: props.isDomestic,
    });
    emit('onFareSelect');
  };
</script>
